import { render } from "./CadastroPJ_Passo_1.vue?vue&type=template&id=3a737af4&scoped=true"
import script from "./CadastroPJ_Passo_1.vue?vue&type=script&lang=js"
export * from "./CadastroPJ_Passo_1.vue?vue&type=script&lang=js"

import "./CadastroPJ_Passo_1.vue?vue&type=style&index=0&id=3a737af4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a737af4"]])

export default __exports__